import { cn } from "utils";
import {
  isStringNull,
  isStringZero,
} from "../table/dashboard/columns/formatDisplay";

export const Tag = ({ value }: { value: string | null }) => {
  const showZero = isStringZero(value ?? "");
  const priceChange = Number(value || "0");
  const finalShowZero = showZero || Math.abs(priceChange) < 0.01;
  const isString = isStringNull(value ?? "");
  const formattedValue = isString
    ? "--"
    : `${priceChange > 0 ? "+" : ""}${((Math.floor(Math.abs(priceChange) * 100) / 100) * Math.sign(priceChange)).toFixed(2)}%`;

  if (isString) {
    return <div className="body_medium_s text-content_primary">--</div>;
  }
  return (
    <div
      className={cn("body_medium_s", {
        "text-content_accent2_primary": priceChange < 0,
        "text-content_accent1_primary": priceChange >= 0,
        "text-content_secondary": finalShowZero,
      })}
    >
      {finalShowZero ? "0.0%" : formattedValue}
    </div>
  );
};
